import AgentAssignmentDropdown from './AgentAssignmentDropdown'

export default function OrderAssignmentModal({
  assignDropdown,
  onClose,
  onAssign,
}: {
  assignDropdown: { orderId: string; anchorEl: HTMLElement } | null
  onClose: () => void
  onAssign: (orderId: string, agentId: string) => void
}) {
  if (!assignDropdown) return null
  return (
    <AgentAssignmentDropdown
      orderId={assignDropdown.orderId}
      anchorEl={assignDropdown.anchorEl}
      onClose={onClose}
      onAssign={onAssign}
    />
  )
}
